import AbsComponent from "../AbsComponent";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from '../../common/bodyScrollLock.es6';

class Sidebar extends AbsComponent{
    constructor(_name='', _store={}, _router={}, _el=''){
        super(_name, _store, _router, _el);

        // new StickySidebar('#sidebar', {
        //     containerSelector: '.gd-search-filter-wrap',
        //     innerWrapperSelector: '.gd-sidebar-inner',
        //     topSpacing: 58,
        //     bottomSpacing: 0,
        //     resizeSensor: true
        // });

        let watchsidebarIsShow = this.watch(this.store.getState, 'sidebarIsShow', this.isEqual);
        this.store.subscribe( watchsidebarIsShow( (_newVal) => {
            $('#sidebar').toggleClass('is-show', _newVal);
            if(_device != 'pc' && _device != 'launcher' && _newVal){
                disableBodyScroll($('.gd-filter-list-wrap')[0]);
            }else{
                enableBodyScroll($('.gd-filter-list-wrap')[0]);
            }
        } ) );

        this.addEvents();
    }

    addEvents(){
        $('.gd-btn-search-filter').on('click', (e)=>{
            this.store.dispatch( this.actions.setSidebarIsshow(true) );
        });

        $(this.el + ' .gd-search-filter .gd-btn-close-layer').on('click', (e)=>{
            this.store.dispatch( this.actions.setSidebarIsshow(false) );
        });
    }

} // end of class
export default Sidebar;